import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fc2fdd5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "notify",
  style: {"text-align":"left"}
}, [
  /*#__PURE__*/_createElementVNode("h3", {
    style: {"text-align":"center"},
    class: "vo-ft-dag"
  }, "请仔细阅读上传内容须知"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" 1、上传的文件必须为双方或多方均"),
    /*#__PURE__*/_createElementVNode("span", null, "已确认并有效盖章"),
    /*#__PURE__*/_createTextVNode("。且"),
    /*#__PURE__*/_createElementVNode("span", null, "认同"),
    /*#__PURE__*/_createTextVNode("文件的法律有效性！")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" 2、上传的文件必须为依照PDF文档,按照原文件的顺序形成一个"),
    /*#__PURE__*/_createElementVNode("span", null, "独立、整体的文档"),
    /*#__PURE__*/_createTextVNode("！")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" 3、上传的文件必须为彩色扫描件，可"),
    /*#__PURE__*/_createElementVNode("span", null, "清楚的识别"),
    /*#__PURE__*/_createTextVNode("文件的内容及相关的图表、签章等！")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, " 4、上传的文件必须为相关类型的合同、协议等名字命名，避免以数字、系列号命名！"),
  /*#__PURE__*/_createElementVNode("p", null, " 5、上传的文件仅在该节点可以进行上传、修正等操作，其他节点不能上传及修改！"),
  /*#__PURE__*/_createElementVNode("p", null, " 6、上传的文件在其他环节只能作为查看、浏览、下载等操作。")
], -1))
const _hoisted_2 = { class: "dialog-footer" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("关 闭")
const _hoisted_4 = { "element-loading-text": "正在提交数据，请稍后" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode(" 拖动文件到此处"),
  /*#__PURE__*/_createElementVNode("em", null, "上传")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, " 允许上传文件类型：pdf文档,office文档,图像(jpg,jpeg,bmp) ", -1))
const _hoisted_7 = { class: "dialog-footer" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("提 交")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("取 消")

import { ref, reactive, unref, onMounted } from 'vue';
import { useRoute } from 'vue-router'

/* Npm */
import { ElMessage, ElForm, UploadFile } from 'element-plus';

/* Components */
import ContractWriter from '../components/0_ContractWriter.vue'
import { GbDialog } from '@/components/GbDialog/Index';

/* Stores & Hooks */
import { useAppStore } from '@/store/app'
import { config } from '@/config/config'

/* Apis */
import { CtAgreeApi } from '../../../apis/contract/contract.api';

/* Dtos */
import { MaterialUploadDto } from '../../../apis/materials/material.dto';
import { CtAuditDto } from '../../../apis/contract/contract.type';


export default /*#__PURE__*/_defineComponent({
  emits: ['refresh'],
  setup(__props, { expose, emit: $emits }) {

const { query } = useRoute()
const { base_url } = config


const login = useAppStore().getLoginInfo

/* 文件上传URL，请求头，上传数据列表 */
const actionUrl = `${base_url}/api/sysmaterial/uploadfile`;
const upHeaders = ref<Record<string, string>>({ "Authorization": `Bearer ${login.token}` })

const uploadSchema = ref<MaterialUploadDto>({
    categroy_id: '0afff935-9ffa-4907-8ce8-a8bf3463b41e',
    ct_num: '',
    material_type: '6c395bee-3033-4b14-b7a0-595d5f1a1556',
    material_type_desc: '签章文件'
})

const writerRef = ref<ComponentRef<typeof ContractWriter>>()
const loading = ref(false)

const showDialog = ref<boolean>(false)
const showUpDialog = ref<boolean>(false)

const countdown = ref(0);
const buttonText = ref('确认');

const submitSchema = ref<CtAuditDto>({
    id: '',
    revision: '',
    remark: '',
    file_total: 0,
    material_list: []
})

let timer: any = null;

/* 确认按钮倒计时 */
const startCountdown = () => {
    countdown.value = 10;
    buttonText.value = `${countdown.value}秒后确认`;
    timer = setInterval(() => {
        countdown.value--;
        if (countdown.value <= 0) {
            clearInterval(timer);
            buttonText.value = '确认';
        } else {
            buttonText.value = `${countdown.value}秒后确认`;
        }
    }, 1000);
};

/* 用户操作 */
const actions = {
    /* 操作警告 */
    notify: (contract: any) => {
        unref(submitSchema).id = contract.id
        unref(submitSchema).revision = contract.revision
        
        showDialog.value = true
        if (timer) {
            clearInterval(timer)
            timer = null
        }
        startCountdown()
    },

    /* 用户操作 */
    sure: () => {
        showDialog.value = false;
        showUpDialog.value = true
    },

    /* 提交操作 */
    submit: async () => {
        const subData = unref(submitSchema);

        if ((subData.material_list || []).length <= 0) {
            ElMessage.warning("未上传附件")
            return
        }

        loading.value = true
        const { succeeded, errors } = await CtAgreeApi(subData)
        loading.value = false
        if (!succeeded) {
            ElMessage.error(errors)
        } else {
            ElMessage.success("操作成功")
            $emits('refresh', succeeded)
            showDialog.value = false
            showUpDialog.value = false
        }
    }
}


/* 上传成功 */
const onUploadSuccess = (res: IResponse, file: UploadFile) => {
    const { succeeded, data } = res;
    if (!succeeded) {
        ElMessage.error("文件上传失败")
    } else {
        ElMessage.success("上传成功")
        unref(submitSchema).material_list!.push(data.id)
    }
};

expose({ showNotify: actions.notify })

onMounted(() => {
    const writer = unref(writerRef);
    writer?.methods.setFormData(query.contractId as string)
})


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_upload_filled = _resolveComponent("upload-filled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(GbDialog), {
      title: "操作警告！",
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showDialog).value = $event)),
      style: {"width":"600px"}
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_button, {
            type: "primary",
            disabled: countdown.value > 0,
            onClick: actions.sure,
            size: "small"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(buttonText.value), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_el_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showDialog.value = false)),
            size: "small"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(GbDialog), {
      title: "上传盖章文件",
      modelValue: showUpDialog.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showUpDialog).value = $event)),
      style: {"width":"650px"}
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_button, {
            disabled: loading.value,
            type: "primary",
            size: "small",
            onClick: actions.submit
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_el_button, {
            disabled: loading.value,
            type: "info",
            size: "small",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (showUpDialog.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
          _withDirectives((_openBlock(), _createBlock(_unref(ElForm), {
            ref: "rmkFormRef",
            model: submitSchema.value,
            "label-position": "top",
            size: "small"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "合同盖章文件" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_upload, {
                    drag: "",
                    multiple: "",
                    style: {"width":"100%"},
                    data: uploadSchema.value,
                    action: actionUrl,
                    headers: upHeaders.value,
                    "on-success": onUploadSuccess
                  }, {
                    tip: _withCtx(() => [
                      _hoisted_6
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_upload_filled)
                        ]),
                        _: 1
                      }),
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["data", "headers"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])), [
            [_directive_loading, loading.value]
          ])
        ])), [
          [_directive_loading, loading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})